import { render, staticRenderFns } from "./AnalyticsKabayan.vue?vue&type=template&id=b0827e2c"
import script from "./AnalyticsKabayan.vue?vue&type=script&lang=js"
export * from "./AnalyticsKabayan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports